var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4061_36376)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7609 0.739136H11.7174H7.54348V1.78261L10.9863 1.78261L6.50001 6.26894L7.23108 7L11.7174 2.51368V5.95653H12.7609V1.78261V0.739136ZM0.239136 2.30435H7.54348V3.34783H1.28261V12.2174H10.1522V6.47827H11.1957V12.2174V13.2609H0.239136V12.2174V3.34783V2.30435Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4061_36376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.5217,
    height: 12.5217,
    fill: "white",
    transform: "translate(0.239136 0.739136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTab);
export default __webpack_public_path__ + "static/media/OpenTab.531f71e84ea4d0a97dbecb7e233bd422.svg";
export { ForwardRef as ReactComponent };